import { ELogLevel, LoggerType } from '@services/errorService';
import { IGeneralRequestResponse } from '@services/httpClientService';

import { IPayPalOrder } from '../../../../model';

import { IGetPayPalOrderResponse } from './model';
import { isGetPayPalOrderResponse } from './model.guard';

export const decodePayPalOrder = (
  response: IGetPayPalOrderResponse,
  logger: LoggerType,
): IGeneralRequestResponse<IPayPalOrder> | null => {
  if (!isGetPayPalOrderResponse(response)) {
    logger({ logLevel: ELogLevel.ERROR, logError: new Error('Could NOT decode paypal get order response.') });
    return null;
  }

  const data = response.paypalOrder.data;

  if (!data.orderInfo?.customer?.shippingAddress) {
    logger({
      logLevel: ELogLevel.ERROR,
      logError: new Error(`Payment service did not return necessary info for order ${data.payPalOrderId}`),
    });
    return null;
  }

  return {
    ...response.paypalOrder,
    data: {
      ...data,
      orderId: data.payPalOrderId,
      deliveryAddress: {
        ...data.orderInfo.customer.shippingAddress,
      },
      customer: {
        ...data.orderInfo.customer,
        email: data.orderInfo.customer.shippingAddress.email,
        phone: data.orderInfo.customer.shippingAddress.phone,
      },
    },
  };
};
